import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 共済契約対象（外）施設等異動　対象者一覧参照API
// API仕様書_法人職員
import {
  IAPI_STA026_Request,
  IAPI_STA026_Response,
} from "../../../type/apiType";

// 申請状況更新API
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";

// 共済契約対象（外）施設等異動　対象者一覧参照API
// API仕様書_法人職員
const httpIAPI_STA026 = async (
  param: IAPI_STA026_Request
): Promise<IAPI_STA026_Response> => {
  let res = await http.post(ApiUrl.API_STA026, {
    ...param,
  });

  return res.data;
};

// 申請状況更新API
const httpIAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpIAPI_STA026, httpIAPI_APP016 };
